import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { CACHED_HEADER } from '@evorait/pace-offline';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { OdataMeasurementToolsInterface } from '../../interfaces/odata-measurement-tools.interface';
import { OdataResponse } from '../../interfaces/online-only.interface';
import {
    MeasurementToolsDetailsModel,
    ODataMeasurementToolsModel,
} from '../../models/low-level/measurement-tools-details.model';
import { UriUtilitiesService } from '../../services/uri-utilities/uri-utilities.service';
import { UserMasterService } from '../../services/user-master/user-master.service';
import { ODataUtilities } from '../../utilities/odata-utilities';

@Injectable({
    providedIn: 'root',
})
export class OdataMeasurementToolsService implements OdataMeasurementToolsInterface {
    public constructor(
        private readonly userMasterService: UserMasterService,
        private readonly http: HttpClient,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly uriUtilities: UriUtilitiesService,
    ) {}

    public getMeasurementTools(): Observable<MeasurementToolsDetailsModel[]> {
        const userModel = this.userMasterService.getSelectedUserModel();
        const query = this.uriUtilities.appendUriFilters(
            this.uriUtilities.getUriForContent() + ENDPOINTS.MeasToolSet,
            userModel,
        );
        const headers = new HttpHeaders({ [CACHED_HEADER]: CACHED_HEADER });

        return this.http.get<OdataResponse<ODataMeasurementToolsModel>>(query, { headers: headers }).pipe(
            map((response) => {
                return ODataUtilities.transformResponseDataToArray(response.d).map(
                    (responseResult: ODataMeasurementToolsModel) =>
                        MeasurementToolsDetailsModel.fromODataMeasurementTools(responseResult),
                );
            }),
            catchError((err) => {
                this.log.error(
                    'OdataMeasurementToolsService: getMeasurementTools: request error:  ' + JSON.stringify(err),
                );
                return throwError(err);
            }),
        );
    }
}
